import styles from './HistorySkeletonLoader.module.scss';

const SkeletonLoader = () => (
	<ul className={styles['skeleton-loader-list']}>
		{[...Array(8)].map((_, index) => (
			<li key={`skeleton-${index}`} className={styles['skeleton-loader-card']}>
				<span className={styles['skeleton-loader-title']} />
				<span className={styles['skeleton-loader-tracking']} />
				<span className={styles['skeleton-loader-status']} />
				<ul>
					<li key='a' />
					<li key='s' />
					<li key='d' />
					<li key='f' />
				</ul>
			</li>
		))}
	</ul>
);

export default SkeletonLoader;
